module.exports = __webpack_public_path__ + "img/lock.a348cc20.svg";